import "./css/adminwithdrawalcustinfo.css";
import { formatDate } from "../../../utils/commonService";

const AdminWithdrawalCustInfo = ({ customerData, onClose }) => {
  return (
    <div className="adminwithdrawalcustinfo-backdrop" onClick={onClose}>
      <div className="adminwithdrawalcustinfo-wrap" onClick={(e) => e.stopPropagation()}>
        <div className="adminwithdrawalcustinfo-header">
          <h2 className="adminwithdrawalcustinfo-title">탈퇴 회원 상세 정보</h2>
          <button className="adminwithdrawalcustinfo-close-btn" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="adminwithdrawalcustinfo-content">
          <section className="adminwithdrawalcustinfo-section">
            <h3 className="adminwithdrawalcustinfo-section-title-withdrawal">탈퇴 정보</h3>
            <div className="adminwithdrawalcustinfo-grid">
              <div className="adminwithdrawalcustinfo-field">
                <label className="adminwithdrawalcustinfo-label">탈퇴 요청일</label>
                <span className="adminwithdrawalcustinfo-value">
                  {formatDate(customerData?.custWithdrawalRequestTime) || "-"}
                </span>
              </div>

              <div className="adminwithdrawalcustinfo-field">
                <label className="adminwithdrawalcustinfo-label">탈퇴 사유</label>
                <span className="adminwithdrawalcustinfo-value">
                  {customerData?.custWithdrawalRequestReason || "-"}
                </span>
              </div>
            </div>
          </section>

          <section className="adminwithdrawalcustinfo-section">
            <h3 className="adminwithdrawalcustinfo-section-title">회원 정보</h3>
            <div className="adminwithdrawalcustinfo-grid">
              <div className="adminwithdrawalcustinfo-field">
                <label className="adminwithdrawalcustinfo-label">아이디</label>
                <span className="adminwithdrawalcustinfo-value">
                  {customerData?.custId || "-"}
                </span>
              </div>

              <div className="adminwithdrawalcustinfo-field">
                <label className="adminwithdrawalcustinfo-label">로그인 타입</label>
                <span className="adminwithdrawalcustinfo-value">
                  {customerData?.custLoginType === "DNBN"
                    ? "동네방네"
                    : customerData?.custLoginType || "-"}
                </span>
              </div>

              <div className="adminwithdrawalcustinfo-field">
                <label className="adminwithdrawalcustinfo-label">이름</label>
                <span className="adminwithdrawalcustinfo-value">
                  {customerData?.custNm || "-"}
                </span>
              </div>

              <div className="adminwithdrawalcustinfo-field">
                <label className="adminwithdrawalcustinfo-label">성별</label>
                <span className="adminwithdrawalcustinfo-value">
                  {customerData?.custGender === "M"
                    ? "남"
                    : customerData?.custGender === "F"
                      ? "여"
                      : "선택안함"}
                </span>
              </div>

              <div className="adminwithdrawalcustinfo-field">
                <label className="adminwithdrawalcustinfo-label">생년</label>
                <span className="adminwithdrawalcustinfo-value">
                  {customerData?.custYearBirth || "-"}
                </span>
              </div>

              <div className="adminwithdrawalcustinfo-field">
                <label className="adminwithdrawalcustinfo-label">사용자 코드</label>
                <span className="adminwithdrawalcustinfo-value">
                  {customerData?.custCode || "-"}
                </span>
              </div>

              <div className="adminwithdrawalcustinfo-field">
                <label className="adminwithdrawalcustinfo-label">연락처</label>
                <span className="adminwithdrawalcustinfo-value">
                  {customerData?.custTelNo || "-"}
                </span>
              </div>
            </div>
          </section>
        </div>

        <div className="adminwithdrawalcustinfo-footer">
          <button
            className="adminwithdrawalcustinfo-btn adminwithdrawalcustinfo-close-footer-btn"
            onClick={onClose}
          >
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminWithdrawalCustInfo;
